import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["windowPane", "toggleButton"]

  switch(event) {
    const selectedWindow = event.params.window
    this.#showWindow(selectedWindow)
    this.#updateButtons(selectedWindow)
  }

  #showWindow(selectedWindow) {
    this.windowPaneTargets.forEach(pane => {
      pane.classList.toggle("hidden", pane.dataset.partnerMetricsWindow !== selectedWindow)
    })
  }

  #updateButtons(selectedWindow) {
    this.toggleButtonTargets.forEach(button => {
      const isActive = button.dataset.partnerMetricsWindowParam === selectedWindow
      button.setAttribute("aria-pressed", isActive.toString())
      button.className = isActive ? button.dataset.activeClass : button.dataset.inactiveClass
    })
  }
}
